@if (!lotSpec?.items?.length && !lotSpec?.colourItems?.length) {
    <div class="absolute-message start-center flex-row">
        <mat-icon class="cb-accent">info_circle</mat-icon>
        <span class="mat-body-2">&nbsp;There are no Items in the Lot Specification</span>
    </div>
} @else {
    @if (!houseAreaItems.length) {
        <div class="absolute-message start-center flex-row">
            <mat-icon class="cb-accent">info_circle</mat-icon>
            <span class="mat-body-2">&nbsp;No items found</span>
        </div>
    }
}
<cdk-virtual-scroll-viewport
    #viewport
    cbFillHeight
    [ngClass]="fullscreen ? 'fullscreen' : ''"
    id="viewport"
    [itemSize]="50"
    [minBufferPx]="viewport?.elementRef?.nativeElement?.clientHeight"
    [maxBufferPx]="viewport?.elementRef?.nativeElement?.clientHeight"
>
    <mat-accordion [multi]="true" class="accordion cb-padding-bottom">
        @for (houseArea of houseAreaItems; track trackBySpecGroup($index, houseArea)) {
            <mat-expansion-panel
                class="panel"
                [id]="HOUSE_AREA_PIN_PREFIX + houseArea.specGroupId"
                [(expanded)]="expandedPanels[houseArea.specGroupId]"
                (expandedChange)="expandedChange()"
            >
                <mat-expansion-panel-header class="cb-padding-top cb-padding-bottom">
                    <mat-panel-title>
                        <span class="mat-body-strong cb-margin-top">{{
                            $any(houseArea).label
                        }}</span>
                    </mat-panel-title>
                    <mat-panel-description class="end-center flex-row">
                        <button
                            mat-icon-button
                            (click)="
                                togglePanelPinned(
                                    $event,
                                    HOUSE_AREA_PIN_PREFIX + houseArea.specGroupId
                                )
                            "
                        >
                            <mat-icon
                                svgIcon="pin"
                                [ngClass]="{
                                    'cb-accent':
                                        userCacheItem.silentData[
                                            HOUSE_AREA_PIN_PREFIX + houseArea.specGroupId
                                        ]
                                }"
                            >
                            </mat-icon>
                        </button>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <!-- List View -->
                @if (listViewEnabled && expandedPanels[houseArea.specGroupId]) {
                    <div
                        class="flex-row flex"
                        (cbAfterInit)="initSpecGroup(houseArea.specGroupId)"
                        (cbOnDestroy)="exitSpecGroup(houseArea.specGroupId)"
                    >
                        @if (readyPanels[houseArea.specGroupId]) {
                            <cb-lot-spec-item-list-table
                                class="flex-col flex"
                                [lotSpec]="lotSpec"
                                [items]="$any(houseArea).items"
                                (specItemDeleted)="specItemDeleted($event)"
                                (colourItemDeleted)="colourItemDeleted($any($event))"
                                (specItemEdited)="specItemEdited($event)"
                                (colourItemEdited)="colourItemEdited($event)"
                            >
                            </cb-lot-spec-item-list-table>
                        }
                    </div>
                }
                <!-- Card View -->
                @if (!listViewEnabled && expandedPanels[houseArea.specGroupId]) {
                    <div
                        class="flex-wrap flex"
                        (cbAfterInit)="initSpecGroup(houseArea.specGroupId)"
                        (cbOnDestroy)="exitSpecGroup(houseArea.specGroupId)"
                    >
                        @if (readyPanels[houseArea.specGroupId]) {
                            @for (
                                lotSpecItem of $any(houseArea).items;
                                track trackByItem($index, lotSpecItem)
                            ) {
                                <div class="flex-col md-50 sm-50 xs-100 gt-md-33">
                                    <div #itemMarker></div>
                                    @if (
                                        isSpecItemInViewport(
                                            viewport?.elementRef?.nativeElement,
                                            itemMarker
                                        )
                                    ) {
                                        <div class="flex-row">
                                            @if (!lotSpecItem.isColourItem) {
                                                <cb-lot-spec-item-card
                                                    class="card cb-margin-right cb-margin-top flex"
                                                    [mappedItem]="lotSpecItem.item"
                                                    [lotSpec]="lotSpec"
                                                    (itemDeleted)="specItemDeleted($event)"
                                                    (itemEdited)="specItemEdited($event)"
                                                ></cb-lot-spec-item-card>
                                            }
                                            @if (lotSpecItem.isColourItem) {
                                                <cb-lot-spec-colour-item-card
                                                    class="card cb-margin-right cb-margin-top flex"
                                                    [mappedItem]="lotSpecItem.item"
                                                    [lotSpec]="lotSpec"
                                                    (itemDeleted)="colourItemDeleted($event)"
                                                    (itemEdited)="colourItemEdited($event)"
                                                >
                                                </cb-lot-spec-colour-item-card>
                                            }
                                        </div>
                                    } @else {
                                        <div class="placeholder-card"></div>
                                    }
                                </div>
                            }
                        }
                    </div>
                }
            </mat-expansion-panel>
        }
        @if (!houseAreaItems) {
            <cb-loading-spinner class="loading-spinner"> </cb-loading-spinner>
        }
    </mat-accordion>
</cdk-virtual-scroll-viewport>
